import useThemeContext from './useThemeContext';

export default function useTheme() {

    const { theme } = useThemeContext();    
    return theme;
}
